import React, { useState, useEffect } from 'react';
import { userApi } from '../../services/consts';
import { tokenHeader, getUserToken, getUsers, dateFormat, getCurrentUser } from "../../services/user-service";
import {
   Alert,
   UncontrolledAlert,
   Card,
   CardBody,
   CardTitle,
   Button,
   Table
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const apiEndPoint = userApi;
// var dateFormat = (dateStr) =>{
//    let date = new Date(dateStr);
//    return date.toLocaleDateString().replaceAll("/","-");;
// } 
const Users = (props) => {
   // For Dismiss Button with Alert
   // const [visible, setVisible] = useState(true);
   const [loaded, setLoaded] = useState(false);
   const [users, setUsers] = useState([]);
   const [loginLevel, setLoginLevel] = useState('');

   var doDelete = (id) => {
      setLoaded(false);
      fetch(apiEndPoint + '/' + id, {
         method: 'delete',
         body: JSON.stringify({ id: id }),
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            [tokenHeader]: getUserToken()
         }
      })
         .then(function (result) {
            // console.log("record deleted.");
            toast.success('User deleted');
            getUsersData();
         })
   }

   var getUsersData = () => {
      getUsers().then((users) => {
         setUsers(users);
      });
   }

   var doEdit = (id) => {
      props.history.push('/user/edit/' + id);
   }

   useEffect(() => {
      if (!loaded) {
         getUsersData();
         setLoaded(true);
         getCurrentUser().then((result) => {
            if (result != null) {
               setLoginLevel(result.level);
            }
         })
      }
   });

   return (
      <div>
         <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
         />
         <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
               <i className="mdi mdi-clipboard-account mr-2"> </i>
            Users
          </CardTitle>
            <CardBody className="">
               {loginLevel == 'Admin' && <Button style={{ marginBottom: '20px' }} color="success" onClick={() => {
                  props.history.push('/user/add');
               }
               }><i className="mdi mdi-account-plus mdi-18px"></i> Add User</Button>}
               <Table style={{ tableLayout: 'fixed' }} striped bordered hover size="sm">
                  <thead>
                     <tr>
                        {/* <th>#</th> */}
                        {loginLevel == 'Admin' && <th style={{ width: '3rem' }}></th>}
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Name</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Email</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Status</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Last Login</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Level</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Created At</th>
                        {loginLevel == 'Admin' && <th style={{ width: '3rem' }}></th>}
                        {/* <th style={{width:'3rem'}}></th> */}
                     </tr>
                  </thead>
                  <tbody>
                     {users.length > 0 ? users.map(item => (
                        <tr key={item.id}>
                           { loginLevel == 'Admin' && <td style={{ textAlign: 'center', color: 'blue' }}>
                              <i className="mdi mdi-pencil-circle mdi-24px" onClick={() => { doEdit(item.id) }}></i>
                           </td>}
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.name ? item.name : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.email ? item.email : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.status ? item.status : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.lastLogin !== null ? new Date(item.lastLogin).toLocaleString() : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.level ? item.level : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.createdAt ? dateFormat(item.createdAt) : '-'}
                           </td>
                           { loginLevel == 'Admin' && <td style={{ textAlign: 'center' }}><Button className="btn btn-sm" style={{ borderRadius: '50px' }} color="danger" onClick={() => { doDelete(item.id) }}>
                              <i className="mdi mdi-delete"></i></Button>
                           </td>}
                        </tr>
                     )) : <tr><td colSpan={6} style={{ textAlign: 'center' }}><b>No Data Available</b></td></tr>}
                  </tbody>
               </Table>
            </CardBody>
         </Card>
      </div>
   );
}

export default Users;
